import React from "react";
import Styles from "./DashboardBoxSmall.module.scss";
import { useTheme } from "../../../../shared/styles/useTheme";
import classNames from "classnames";
import { Link } from "react-router-dom";
import { Icon } from "@/App/components/@remote";

type Props = {
  title?: string;
  footertext?: string;
  className?: string;
  link?: string;
  children: React.ReactNode;
};

export const DashboardBoxSmall = ({ title, footertext, className, link, children }: Props) => {
  const { primaryColor } = useTheme();

  return (
    <div className={classNames(Styles.dashboardBoxSmallWrapper, className)}>
      <h2 className={classNames(Styles.title, "oswald")}>{title}</h2>
      <div className={Styles.children}>{children}</div>
      {link ? (
        <div className={Styles.footer}>
          <div className={Styles.footerLink}>
            <Link to={link} className={Styles.link}>
              <span>{footertext}</span> <Icon className={classNames(Styles.arrow, primaryColor)} name={"arrowRight"} />
            </Link>
          </div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
